var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91678 10.4167L16.6251 2.625M7.91678 10.4167L10.6876 15.375C10.7224 15.4428 10.7781 15.5003 10.8483 15.5406C10.9185 15.5809 11.0001 15.6023 11.0834 15.6023C11.1668 15.6023 11.2484 15.5809 11.3186 15.5406C11.3888 15.5003 11.4445 15.4428 11.4793 15.375L16.6251 2.625M7.91678 10.4167L2.37512 7.9375C2.29932 7.90642 2.23509 7.85653 2.19006 7.79374C2.14503 7.73096 2.12109 7.65793 2.12109 7.58333C2.12109 7.50873 2.14503 7.4357 2.19006 7.37292C2.23509 7.31014 2.29932 7.26024 2.37512 7.22917L16.6251 2.625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.3759497fc3c1d13840910532122d9d5b.svg";
export { ForwardRef as ReactComponent };